<template>
    <section class="m-job">
        <section class="m-banner">
            <img src="../../assets/images/job/banner.jpg" alt="">
        </section>
        <section class="m-nav-job">
            <a :href="item.link" v-for="(item,index) in nav" :key="index">
                <div class="hot" v-if="index === 4">HOT</div>
                <div class="icon">
                    <img :src="item.icon" :alt="item.name">
                </div>
                <div class="name">{{item.name}}</div>
            </a>
        </section>
        <section class="m-floor-1">
            <div class="common-top">
                <span>
                    <i></i>
                    特招推荐
                </span>
                <a href="https://job.gxnews.com.cn/wap/index.php?c=article&nid=43">
                    更多
                    <em></em>
                </a>
            </div>
            <div class="poster">
                <img src="../../assets/images/job/pic_1.jpg" alt="">    
            </div>
            <div class="job-info">
                <div class="tab">
                    <a href="javascript:;" v-for="(item,index) in type" :key="index" :class="{'cur': num === index}" @click="change(index)">{{item}}</a>
                </div>
                <div class="job-meeting" v-if="num === 0">
                    <ul>
                        <li class="m1">
                            <router-link to="/job">
                                <div class="date">4月28日</div>
                                <div class="name">理工专场</div>
                            </router-link>
                        </li>
                        <li class="m2">
                            <router-link to="/job">
                                <div class="date">4月28日</div>
                                <div class="name">国企专场</div>
                            </router-link>
                        </li>
                        <li class="m3">
                            <router-link to="/job">
                                <div class="date">4月28日</div>
                                <div class="name">应届生专场</div>
                            </router-link>
                        </li>
                        <li class="m4">
                            <router-link to="/job">
                                <div class="date">4月28日</div>
                                <div class="name">海归专场</div>
                            </router-link>
                        </li>
                        <li class="m5">
                            <router-link to="/job">
                                <div class="date">4月28日</div>
                                <div class="name">东北专场</div>
                            </router-link>
                        </li>
                        <li class="m6">
                            <router-link to="/job">
                                <div class="date">4月28日</div>
                                <div class="name">柳州专场</div>
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div class="job-meeting" v-if="num === 1">
                    <ul>
                        <li class="m1">
                            <router-link to="/job">
                                <div class="date">4月28日</div>
                                <div class="name">民企专场</div>
                            </router-link>
                        </li>
                        <li class="m2">
                            <router-link to="/job">
                                <div class="date">4月28日</div>
                                <div class="name">国企专场</div>
                            </router-link>
                        </li>
                        <li class="m3">
                            <router-link to="/job">
                                <div class="date">4月28日</div>
                                <div class="name">应届生专场</div>
                            </router-link>
                        </li>
                        <li class="m4">
                            <router-link to="/job">
                                <div class="date">4月28日</div>
                                <div class="name">海归专场</div>
                            </router-link>
                        </li>
                        <li class="m5">
                            <router-link to="/job">
                                <div class="date">4月28日</div>
                                <div class="name">东北专场</div>
                            </router-link>
                        </li>
                        <li class="m6">
                            <router-link to="/job">
                                <div class="date">4月28日</div>
                                <div class="name">柳州专场</div>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="m-floor-2">
            <div class="common-top">
                <span>
                    <i></i>
                    高校专场
                </span>
                <a href="https://job.gxnews.com.cn/wap/index.php?c=article&nid=44">
                    更多
                    <em></em>
                </a>
            </div>
            <dl class="performance">
                <dt>
                    <router-link to="/job">
                        <div class="common-tip"><i></i>视频招聘</div>
                        <img src="../../assets/images/job/pic_2.jpg" alt="">    
                    </router-link>
                </dt>
                <dd>
                    <ul>
                        <li>
                            <router-link to="/job">
                                <img src="../../assets/images/job/pic_3.jpg" alt="">    
                            </router-link>    
                        </li>
                        <li>
                            <router-link to="/job">
                                <img src="../../assets/images/job/pic_3.jpg" alt="">    
                            </router-link>    
                        </li>
                    </ul>
                </dd>
            </dl>
            <a href="javascript:;" class="change">换一批</a>
        </section>
        <section class="m-floor-3">
            <div class="common-top">
                <span>
                    <i class="j1"></i>
                    国企专场
                </span>
                <a href="https://job.gxnews.com.cn/wap/index.php?c=article&nid=45">
                    更多
                    <em></em>
                </a>
            </div>
            <dl class="performance">
                <dt>
                    <router-link to="/job">
                        <div class="common-tip"><i></i>视频招聘</div>
                        <img src="../../assets/images/job/pic_2.jpg" alt="">    
                    </router-link>
                </dt>
                <dd>
                    <ul>
                        <li>
                            <router-link to="/job">
                                <img src="../../assets/images/job/pic_3.jpg" alt="">    
                            </router-link>    
                        </li>
                        <li>
                            <router-link to="/job">
                                <img src="../../assets/images/job/pic_3.jpg" alt="">    
                            </router-link>    
                        </li>
                    </ul>
                </dd>
            </dl>
            <a href="javascript:;" class="change">换一批</a>
        </section>
        <section class="m-floor-4">
            <div class="common-top">
                <span>
                    <i class="j2"></i>
                    其他专场
                </span>
                <a href="https://job.gxnews.com.cn/wap/index.php?c=article&nid=46">
                    更多
                    <em></em>
                </a>
            </div>
            <dl class="performance">
                <dt>
                    <router-link to="/job">
                        <div class="common-tip"><i></i>视频招聘</div>
                        <img src="../../assets/images/job/pic_2.jpg" alt="">    
                    </router-link>
                </dt>
                <dd>
                    <ul>
                        <li>
                            <router-link to="/job">
                                <img src="../../assets/images/job/pic_3.jpg" alt="">    
                            </router-link>    
                        </li>
                        <li>
                            <router-link to="/job">
                                <img src="../../assets/images/job/pic_3.jpg" alt="">    
                            </router-link>    
                        </li>
                    </ul>
                </dd>
            </dl>
            <a href="javascript:;" class="change">换一批</a>
        </section>
        <section class="m-floor-5">
            <div class="common-top">
                <span>
                    <i class="j3"></i>
                    HR直播招聘
                </span>
                <router-link to="/job">
                    更多
                    <em></em>
                </router-link>
            </div>
            <ul>
                <li>
                    <router-link to="/job">
                        <div class="job-live"><i></i>直播中</div>
                        <img src="../../assets/images/job/pic_4.jpg" alt="">
                        <div class="msg">
                            <p>华为集团</p>
                            <p>提供客服、工程师等岗位</p>
                            <p>
                                <img src="../../assets/images/job/avatar.jpg" alt="">
                                方游仪 招聘经理    
                            </p>
                        </div>        
                    </router-link>
                </li>
                <li>
                    <router-link to="/job">
                        <img src="../../assets/images/job/pic_4.jpg" alt="">
                        <div class="msg">
                            <p>华为集团</p>
                            <p>提供客服、工程师等岗位</p>
                            <p>
                                <img src="../../assets/images/job/avatar.jpg" alt="">
                                方游仪 招聘经理    
                            </p>
                        </div>        
                    </router-link>
                </li>
            </ul>
        </section>
        <section class="m-floor-6">
            <div class="common-top">
                <span>
                    <i></i>
                    知名企业推荐
                </span>
                <a href="http://job.gxnews.com.cn/wap/index.php?c=company&rec=1">
                    更多
                    <em></em>
                </a>
            </div>
            <ul>
                <li v-for="(company,index) in companylist" :key="index">
                    <a :href="company.url"><dl>
                        <dt>
                            <img :src="company.hot_pic_n" alt="">   
                        </dt>
                        <dd>
                            <p>{{company.name}}</p>
                            <p>
                                {{company.pr_n}}
                                <em>|</em>
                                {{company.mun_n}}
                                <em>|</em>
                                {{company.hy_n}}
                            </p>
                            <p>
                                <span>公司福利 {{company.welfare}}</span>
                            </p>
                        </dd>
                    </dl>
                    <div class="jobs-info" v-if="company.jobList">
                        热招：<span>{{company.jobList.length}}个</span>职位
                    </div>
                    </a>
                </li>
            </ul>
        </section>
        <section class="m-floor-7">
            <div class="common-top">
                <span>
                    <i></i>
                    热门岗位推荐
                </span>
                <a href="http://job.gxnews.com.cn/wap/index.php?c=job">
                    更多
                    <em></em>
                </a>
            </div>
            <ul>
                <li v-for="(item,index) in joblist" :key="index">
                    <a :href="item.url">
                    <div class="m1">
                        <span>{{item.name}}</span>
                        <span>{{item.job_salary}}</span>
                    </div>
                    <div class="m2">
                        <em>{{item.com_name}}</em> 
                        <span>|</span>
                        {{item.job_one_n}}
                    </div>
                    <div class="m3">
                        <span>{{item.job_city_two}}/{{item.job_city_three}}</span>
                        <span>{{item.job_edu}}</span>
                        <span>{{item.job_exp}}</span>
                        <span>{{item.job_number}}</span>
                    </div>
                    <div class="m4">
                        <span>公司福利 {{item.companyInfo.welfare}}</span>
                    </div>
                    </a>
                </li>
            </ul>
        </section>
    </section>
</template>

<script>
    import jsonp from 'jsonp'
    export default {
        data(){
            return{
                nav:[
                    {icon: require('../../assets/images/job/nav_ico_1.png'), name: '职业库', link:"http://job.gxnews.com.cn/wap/index.php?c=job"},
                    {icon: require('../../assets/images/job/nav_ico_2.png'), name: '企业库', link:"http://job.gxnews.com.cn/wap/index.php?c=company"},
                    {icon: require('../../assets/images/job/nav_ico_3.png'), name: '人才库', link:"http://job.gxnews.com.cn/wap/index.php?c=resume"},
                    {icon: require('../../assets/images/job/nav_ico_4.png'), name: '视频招聘', link:""},
                    {icon: require('../../assets/images/job/nav_ico_5.png'), name: 'HR直播', link:""},
                ],
                type: ['投简历', '来招聘'],
                num: 0,
                companylist:[],
                joblist:[],
            }
        },
        methods:{
            change(index){
                this.num = index;
            }
        },
        mounted(){
            
            jsonp('https://job.gxnews.com.cn/api/json/index.php?m=job&c=hotjob&limit=3', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("companylist",data);
                    this.companylist = data.data;
                }
            })

            jsonp('https://job.gxnews.com.cn/api/json/index.php?m=job&c=company_job&limit=10', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("jobList",data);
                    this.joblist = data.data;
                }
            })
        }
    }
</script>

<style lang="less" scoped>
    .common-top{
        display: flex;
        align-items: center;
        margin-bottom: 0.45rem;
        span,a{
            flex: 1;
        }
        span{
            font-size: 0.45rem;
            color: #000;
            font-weight: bold;
        }
        i{
            display: inline-block;
            width: 0.1rem;
            height: 0.4rem;
            background: #39b583;
            border-radius: 0.2rem;
            vertical-align: middle;
        }
        .j1{
            background: #5797d4;
        }
        .j2{
            background: #4abbc3;
        }
        .j3{
            background: #4be1fc;
        }
        a{
            text-align: right;
            font-size: 0.35rem;
            color: #adadad;
        }
        em{
            display: inline-block;
            vertical-align: middle;
            width: 0.4rem;
            height: 0.4rem;
            background: url("../../assets/images/job/more.jpg") no-repeat;
            background-size: 100%;
        }
    }
    .performance{
        dt{
            position: relative;
            margin-bottom: 0.5rem;
            img{
                width: 100%;
                border-radius: 0.2rem;
            }
            .common-tip{
                position: absolute;
                padding: 0.1rem 0.3rem;
                top: 0;
                left: 0.25rem;
                background: #dc2625;
                border-bottom-left-radius: 0.2rem;
                border-bottom-right-radius: 0.2rem; 
                color: #fff;
                font-size: 0.35rem;
                i{
                    display: inline-block;
                    vertical-align: middle;
                    width: 0.4rem;
                    height: 0.3rem;
                    background: url("../../assets/images/job/live.png") no-repeat;
                    background-size: 100%;
                    margin-right: 0.1rem;
                }
            }
        }
        dd{
            ul{
                display: flex;
            }
            li{
                flex: 1;
                border-radius: 0.15rem;
                &:nth-of-type(1){
                    margin-right: 0.2rem;
                }
                &:nth-of-type(2){
                    margin-left: 0.2rem;
                }
                img{
                    width: 100%;
                    border-radius: 0.2rem;
                }
            }
        }
    }
    .change{
        display: block;
        margin-top: 0.45rem;
        background: #ededed;
        border-radius: 0.35rem;
        text-align: center;
        font-size: 0.4rem;
        padding: 0.15rem 0;
        color: #333;
    }
    .m-banner{
        img{
            width: 100%;
        }
    }
    .m-nav-job{
        padding: 0.3rem 0;
        display: flex;
        justify-content: flex-start;
        flex-direction: row;
        flex-wrap: wrap;
        border-bottom: 0.2rem solid #f4f4f4;
        a{
            flex: 1;
            text-align: center;
            position: relative;
        }
        img{
            width: 55%;
        }
        .name{
            margin-top: 0.05rem;
            font-size: 0.38rem;
            color: #000;
        }
        .hot{
            position: absolute;
            background: #dc2625;
            border-radius: 0.2rem;
            padding: 0 0.12rem;
            color: #fff;
            right: 0.2rem;
        }
    }
    .m-floor-1{
        padding: 0.4rem 0.3rem;
        border-bottom: 0.2rem solid #f4f4f4;
        .poster{
            margin-bottom: 0.45rem;
            img{
                width: 100%;
                border-radius: 0.2rem;
            }
        }
        .job-info{            
            .tab{
                display: flex;
                margin-bottom: 0.5rem;
                a{
                    flex: 1;
                    text-align: center;
                    height: 0.75rem;
                    line-height: 0.75rem;
                    background: #efefef;
                    font-size: 0.4rem;
                    color: #000;
                    border-radius: 0.15rem;
                    &:nth-of-type(1){
                        margin-right: 0.2rem;
                    }
                    &:nth-of-type(2){
                        margin-left: 0.2rem;
                    }
                }
                .cur{
                    background: #39b583;
                    color: #fff;
                }
            }
        }
        .job-meeting{
            overflow: hidden;
            li{
                width: 31%;
                float: left;
                border-radius: 0.15rem;
                text-align: center;
                margin: 0 0.09rem 0.25rem 0.08rem;
                padding: 0.2rem 0;
                &:nth-of-type(3n){
                    margin-right: 0;
                }
                .date{
                    font-size: 0.4rem;
                    font-weight: bold;
                }
                .name{
                    font-size: 0.35rem;
                    margin-top: 0.05rem;    
                }
            }
            .m1{
                border: 1px solid #f8ede9;
                background: #fef6f4;
                .date{
                    color: #bf6751;
                }
                .name{
                    color: #bf6751;    
                }    
            }
            .m2{
                border: 1px solid #e3e9f5;
                background: #f4f7fe;
                .date{
                    color: #3f61ba;
                }
                .name{
                    color: #3f61ba;    
                }    
            }
            .m3{
                border: 1px solid #f8ede9;
                background: #fef6f4;
                .date{
                    color: #dc9249;
                }
                .name{
                    color: #dc9249;    
                }    
            }
            .m4{
                border: 1px solid #ebe7f6;
                background: #f7f4fd;
                .date{
                    color: #765ba8;
                }
                .name{
                    color: #765ba8;    
                }    
            }
            .m5{
                border: 1px solid #faf5e1;
                background: #fefbea;
                .date{
                    color: #938944;
                }
                .name{
                    color: #938944;    
                }    
            }
            .m6{
                border: 1px solid #e6f5f8;
                background: #f0fafb;
                .date{
                    color: #428f95;
                }
                .name{
                    color: #428f95;    
                }    
            }
        }
    }
    .m-floor-2{
        padding: 0.4rem 0.3rem;    
    }
    .m-floor-3{
        padding: 0.2rem 0.3rem;    
    }
    .m-floor-4{
        padding: 0.2rem 0.3rem;    
    }
    .m-floor-5{
        padding: 0.4rem 0.3rem;
        ul{
            display: flex;
        }
        li{
            flex: 1;
            position: relative;
            &:nth-of-type(1){
                margin-right: 0.2rem;
            }
            &:nth-of-type(2){
                margin-left: 0.2rem;
            }
            img{
                width: 100%;
                border-radius: 0.2rem;
            }
            .job-live{
                position: absolute;
                padding: 0.05rem 0.25rem;
                top: 0;
                left: 0.25rem;
                background: #dc2625;
                border-radius: 0.3rem;
                color: #fff;
                font-size: 0.35rem;
                i{
                    display: inline-block;
                    vertical-align: middle;
                    width: 0.4rem;
                    height: 0.3rem;
                    background: url("../../assets/images/job/live.png") no-repeat;
                    background-size: 100%;
                    margin-right: 0.1rem;
                }
            }
            .msg{
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                background: rgba(255,255,255,0.3);
                padding: 0.3rem 0.2rem;
                box-sizing: border-box;
                p{
                    color: #fff;
                    font-size: 0.35rem;
                    margin-bottom: 0.08rem;
                    &:nth-of-type(1){
                        font-size: 0.46rem;
                        font-weight: bold;
                    }
                    &:nth-of-type(2){
                        font-size: 0.36rem;
                    }
                }
                img{
                    width: 20%;
                    border-radius: 50%;
                    margin-right: 0.1rem;
                }
            }
        }    
    }  
    .m-floor-6{
        padding: 0.2rem 0.3rem;
        li{
            background: #fff;
            box-shadow: 0 0 0.2rem #ccc;
            box-sizing: border-box;
            padding: 0.35rem 0.3rem;
            border-radius: 0.15rem;
            margin-bottom: 0.45rem;
            a{
                color: #333;
            }
            dl{
                display: flex;
            }
            dt{
                width: 1.7rem;
                height: 1.7rem;
                img{
                    width: 100%;
                }
            }
            dd{
                flex: 1;
                padding-left: 0.3rem;
                p{
                    margin-bottom: 0.1rem;
                    &:nth-of-type(1){
                        font-weight: bold;
                        font-size: 0.45rem;
                    }
                    &:nth-of-type(2){
                        font-size: 0.32rem;
                        em{
                            font-style: normal;
                        }
                    }
                    &:nth-of-type(3){
                        font-size: 0.32rem;
                        span{
                            margin-right: 0.3rem;
                        }
                    }
                }
            }
        }
        .jobs-info{
            margin-top: 0.1rem;
            font-size: 0.32rem;
            span{
                color: #00b58c;
            }
        }    
    } 
    .m-floor-7{
        padding: 0 0.3rem 1.6rem 0.3rem; 
        li{
            background: #fff;
            box-shadow: 0 0 0.2rem #ccc;
            box-sizing: border-box;
            padding: 0.35rem 0.3rem;
            border-radius: 0.15rem;
            margin-bottom: 0.45rem;
            font-size: 0.35rem;
            a{
                color:#333;
            }
        }
        .m1,.m2,.m3,.m4{
            margin-bottom: 0.1rem;
        }
        .m1{
            display: flex;
            font-size: 0.46rem;
            font-weight: bold;
            span{
                flex: 1;
                &:nth-of-type(2){
                    color: #f41414;
                    text-align: right;
                    font-size: 0.4rem;
                }
            }
        }
        .m3,.m4{
            span{
                margin-right: 0.2rem;
            }
        }
        em{
            font-style: normal;
            color: #00b58c;
            margin-right: 0.1rem;
        }
    } 
</style>